import { useIntl } from 'react-intl';
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';

const LOCALE_TO_DATE_FNS_LOCALE = {
  'fr': frLocale,
  'en': enLocale
}

const useDateFnsLocale = () => {
  const { locale } = useIntl();

  const shortLocale = locale.match(/../)[0] || 'en';

  return (LOCALE_TO_DATE_FNS_LOCALE[shortLocale])
}

export default useDateFnsLocale;
